import { useAppSelector } from '@/shared/hooks';

import { templatesModel } from '@/entities/templates';

import { buildGalleryItems, findGalleryItem } from '../lib';

// The template card a start page names, read from the clinic's catalog in
// any content language.
export const useStartTemplate = (card: {
  seriesId?: string;
  schemaId?: string;
}) => {
  const schemas = useAppSelector(
    templatesModel.selectors.selectPublishedEncounterSchemas,
  );
  const templates = useAppSelector(
    templatesModel.selectors.selectActiveDocumentTemplates,
  );

  return findGalleryItem(buildGalleryItems({ schemas, templates }), card);
};
